import { NavLink, Outlet } from "react-router-dom"

export default function StartLayout() {
  return (
    <div className="container help-layout start" dir="rtl">

      <h2>ابدأ التعلم </h2>
      <h4 className="layout-title">
        يتكون الاختبار النظري من مجموعة تتكون من حوالي 1800 سؤال ، ومن المستحيل حفظ جميع الإجابات وتذكرها.

      </h4>
      <p >
        هنا سوف نقدم طريقة الدراسة على موقع <span className="text-primary-color"> 1sTest </span>  ونوضح بمساعدة شهادات الطلاب على الموقع كيف تعمل هذه الطريقة.

      </p>

      <nav className="nav-list">

        <NavLink to="quiz" className='nav-link'>اختبار</NavLink>
        <NavLink to="learn" className='nav-link' >أدرس </NavLink>
      </nav>

      <Outlet />


    </div>
  )
}
